import { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { toast, ToastContainer } from "react-toastify";
import { userSchema_login } from "../validations/userSchema_login"; //mappedPlans
import { AuthContext } from '../context/authContext';
import { Link } from "react-router-dom";

import { Input, Label, Button } from "../components/ui";


export const LoginPage = () => {

	const auth = useContext(AuthContext)
	const { user, token, role } = useContext(AuthContext)

	const [showPassword, setShowPassword] = useState(false);
	const [loading, setLoading] = useState(false);
	const { register, handleSubmit, watch, formState: { errors }, } = useForm({
		resolver: zodResolver(userSchema_login)
	});


	const onSubmit = async (data) => {
		console.log(data);
		setLoading(true);

		try {

			const response = await fetch(
				//`${baseURL}authentication/login`,
				`/api/authentication/login`, // #Df1 ---> Ver mail Dockerizacion SUBSE
				{
					method: "POST",
					headers: {
						"Content-type": "application/json"
					},
					body: JSON.stringify(data)
				}
			);

			const parseRes = await response.json();
			console.log('Login response:', parseRes);
			console.log('isEspecial from backend:', parseRes.isEspecial);
			console.log('user_municipio from backend:', parseRes.user_municipio);
			console.log('🔍 parseRes.entidad_id:', parseRes.entidad_id, 'tipo:', typeof parseRes.entidad_id);
			console.log('🔍 parseRes keys:', Object.keys(parseRes));

			if (parseRes.jwtToken) {
				// Extract user data including role from the response
				/*const userData = {
				  name: parseRes.user?.name || data.email, // Use email as fallback if name not provided
				  role: parseRes.user?.role || 'user' // Default to 'user' if role not provided
				};*/
				console.log('🔍 ANTES de auth.login - entidad_id:', parseRes.entidad_id, 'es undefined?:', parseRes.entidad_id === undefined, 'es null?:', parseRes.entidad_id === null);
				//toast.success("¡Inicio de sesión exitoso!");
				auth?.login(parseRes.username, parseRes.jwtToken, parseRes.role, parseRes.userId, parseRes.mustChangePassword, parseRes.isEspecial, parseRes.user_municipio, parseRes.entidad_id);

				auth?.user(parseRes.username)
				auth?.token(parseRes.jwtToken)
				auth?.role(parseRes.role)
				auth?.userId(parseRes.userId)
				auth?.mustChangePassword(parseRes.mustChangePassword)
				
			} else {				
				toast.error(parseRes);//muestra Usuario o contraseña invalidos
			}

		} catch (err) {
			//console.error(err.message);
			toast.error(`Error al conectar. Por favor vuelva a intentarlo`);
		} finally {
			setLoading(false);
		}

	};
	const iconColorClass = showPassword
		? 'text-blue-400 hover:text-blue-600'  // Azul cuando está abierto (Mostrando)
		: 'text-blue-400 hover:text-blue-600'; // Gris cuando está cerrado (Oculto)

	const BaseEyePaths = (
		<>
			{/* Paths del ojo abierto y el iris */}
			<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
			<circle cx="12" cy="12" r="3"></circle>
		</>
	);
	// ----------------------------------------------------------------------
  // 👁️ SVG del Ojo Abierto (Mostrar Contraseña)
  // ----------------------------------------------------------------------
	const EyeIcon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			className="w-6 h-6" // Tamaño del SVG con Tailwind
		>
			{BaseEyePaths}
		</svg>
	);

	// ----------------------------------------------------------------------
	// 🚫 SVG del Ojo Tachado (Ocultar Contraseña)
	// ----------------------------------------------------------------------
	const EyeSlashIcon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			className="w-6 h-6"
		>
			{BaseEyePaths}
			{/* 💥 EL DETALLE: La línea diagonal que cruza el ojo */}
			{/* La línea va de la esquina superior izquierda a la inferior derecha */}
			<line x1="1" y1="1" x2="23" y2="23" strokeWidth="2.5" />
		</svg>
	);

	return (
		<>
			<div className="flex min-h-screen flex-1 flex-col justify-start pt-20 px-6 py-12 lg:px-8 bg-gray-50 dark:bg-gray-900">

				<div className="sm:mx-auto sm:w-full sm:max-w-lg">
					<h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900 dark:text-white">
						Ingreso de usuario
					</h2>
					<p className="mt-2 text-center text-sm text-gray-600 dark:text-gray-400">
						RED - Registro de Entidades Deportivas
					</p>
				</div>

				<div className="mt-8 sm:mx-auto sm:w-full sm:max-w-lg">
					<div className="bg-white dark:bg-gray-800 py-8 px-4 shadow sm:rounded-lg sm:px-10">
						<form className="space-y-6" onSubmit={handleSubmit(onSubmit)}>

						<div>
							<Label htmlFor="email">Email</Label>
							<div className="mt-2">
								<Input
									id="email"
									type="email"
									placeholder='correo@gmail.com'
									required
									{...register("email")}
								/>
							</div>
						</div>

						<div>
							<div className="flex items-center justify-between">
								<Label htmlFor="password">Contraseña</Label>
								<div className="text-sm">
									<Link to="/forgot-password" className="font-semibold text-indigo-600 hover:text-indigo-500">
										Olvidé mi contraseña
									</Link>
								</div>
							</div>
							<div className="mt-2" style={{ position: 'relative' }}>
								<Input
									id="password"
									type={showPassword ? "text" : "password"}
									placeholder="********"
									required
									{...register("password")}
								/>
								<button
									type="button"
									onClick={() => setShowPassword(!showPassword)}
									// Agregamos el tamaño del icono con text-xl para una buena visualización
									className={`absolute inset-y-0 right-0 flex items-center pr-3 text-xl leading-none cursor-pointer focus:outline-none ${iconColorClass}`}
									aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
								>
									{/* Renderiza el SVG apropiado */}
									{showPassword ? EyeSlashIcon : EyeIcon}
								</button>								
							</div>
						</div>

						<Button variant="subse" type="submit" disabled={loading}>
							{loading ? (
								<svg className="animate-spin -ml-1 mr-2 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
									<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
									<path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
								</svg>
							) : 'Ingresar'}
						</Button>
					</form>					
					</div>
				</div>
				<ToastContainer />
			</div>
		</>
	)
}